
export class Judges {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "Judges";
    this.scene = "Judges";
    this.data = [];
    this.page = 17;
  }

  async preview({ options }) {
    this.onAir = false;

    await this.updateData({ options, show: 1 });
    // await this.updateData({ options, show: 2 });
    // await this.updateData({ options, show: 3 });
    // await this.updateData({ options, show: 4 });
    await this.sendPreview("page:read " + this.page);
  }
  async animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }

  async updateData({ options, show }) {
    let xml = await this.getVizPage({ page: this.page, show }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml.payload.field.find((item) => {
        return item.attr.name === "013";
      }).value = ((options?.game?.judges?.[0]?.first_name.toUpperCase() || "") + (options?.game?.judges?.[0]?.last_name.toUpperCase() || ""));
    
      xml.payload.field.find((item) => {
        return item.attr.name === "014";
      }).value = (options?.game?.judges?.[0]?.nation?.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "023";
      }).value = ((options?.game?.judges?.[1]?.first_name.toUpperCase() || "") + (options?.game?.judges?.[1]?.last_name.toUpperCase() || ""));
    
      xml.payload.field.find((item) => {
        return item.attr.name === "024";
      }).value = (options?.game?.judges?.[1]?.nation?.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "033";
      }).value = ((options?.game?.judges?.[2]?.first_name.toUpperCase() || "") + (options?.game?.judges?.[2]?.last_name.toUpperCase() || ""));
    
      xml.payload.field.find((item) => {
        return item.attr.name === "04";
      }).value = (options?.game?.judges?.[2]?.nation?.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "002";
      }).value = "JUDGES";

      await this.updateVizPage({
        page: this.page,
        data: xml,
        escape: false,
        show,
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  update({ options }) {}
}
